module.exports = __webpack_public_path__ + "img/reveal_opened.76f37cb4.svg";